<div class="o-modal--alert o-modal__success--verde o-modal--medium" id="mod-ap-req" style="width: 100%;">
    <div class="o-modal__head">
        <span class="o-modal__close close-modal" matDialogClose></span>
        <label class="o-title o-title--white o-title--medium">{{ 'ModalAcceptPolicyPortal.titleAccept' | translate}}</label>
    </div>
    <div class="o-modal__body">
        <p>{{ 'ModalAcceptPolicyPortal.bodyAccept' | translate}}</p>
        <textarea input class="o-form__textarea" placeholder="{{ 'ModalAcceptPolicyPortal.placeholderComment' | translate}}" [(ngModel)]="observation"></textarea>
    </div>

    <div class="o-modal__footer">
        <div>
            <span mat-button mat-dialog-close class="btn btn--default"><u>{{ 'ModalAcceptPolicyPortal.btnCancel' | translate }}</u></span>
            <button mat-button class="btn btn--primary" (click)="onSubmit()">{{ 'ModalAcceptPolicyPortal.btnAccept'| translate }}</button>
        </div>
    </div>
</div>